import moment from 'moment';
let searchDate = moment().startOf().format('YYYYMMDD');

export default {
	asPartInfo: [],
	gridList: [],
	useYnList: [], // PWAYN 콤보박스 리스트
	opCdList: [], // op코드 콤보박스 리스트
	searchParams: SEARCH_PARAMS(),
	groups: GROUPS(),
	cmpnDisabled: false
};
function GROUPS() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
function SEARCH_PARAMS() {
	return {
		stdDt: searchDate,
		partNo: ''
	};
}

export { SEARCH_PARAMS, GROUPS };
